module.exports = __webpack_public_path__ + "static/media/PTTA-final-2.45b51638.mp3";